$.ready(function() {
	$(document).on('keydown', function(e) {
		if (e.keyCode === 66) {
			game.toggleClass('blink');
		}
	});
});



/** WEBPACK FOOTER **
 ** ./public-src/js/toggle.js
 **/